/*
 Refer: https://tigerabrodi.blog/the-story-behind-tailwinds-mergeClassnames-function
*/

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

const mergeClassnames = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};

export { mergeClassnames };
